import {gql} from 'apollo-angular';


export const emailTemplatesGql = gql`
query ReloadEmailTemplatesGql($adoptedEventId: [Int!]) {
  AdoptedEvent(adoptedEventId: $adoptedEventId) {
    tieredEmailTemplates {
      emgmtOocpeTemplateId
      pdefProgramGroupTemplateId
      pdefProgramTemplateId
      odefOrgOfficeTemplateId
      sysTemplateTypeDescription
      subject
      sysTemplateTypeName
      content
    }
  }
}
`;